<template>
  <div class="widget-item" :id="widget.object.wid" :style="style">
    <CalendarView class="calendar-app" :app="widget.object" @saveData="saveAppData" />
  </div>
</template>

<script>
  import CalendarView from '@/components/apps/calendar/CalendarView.vue';
  import templateWidget from '@/components/widgets/templates/mixins/templateWidget';
  import { simpleTypeMixin } from '@/helpers';
  import { SET_APP_DATA } from '@/store/actions/player';

  export default {
    name: 'CalendarWidget',

    components: { CalendarView },

    mixins: [simpleTypeMixin, templateWidget],

    props: {
      widget: {
        type: Object,
        required: true,
      },
    },

    computed: {
      style() {
        return Object.assign({}, this.defaultStyling(this.widget), {
          overflow: 'hidden',
        });
      },
    },

    methods: {
      saveAppData(data) {
        const dataToSave = data || null;
        this.$store.commit(SET_APP_DATA, {
          appId: this.widget.object.wid,
          appData: { appType: this.widget.object.item_type, data: dataToSave },
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .widget-item {
    position: absolute;
    overflow: hidden;
  }
</style>
